import { load_script } from '@phi/util/dom';
import { Option } from '@vaaas/fpts/option';
import { Result, map } from '@vaaas/fpts/result';

let instance: Option<IClarity>;

export interface IClarity {
    (...xs: unknown[]): unknown;
}

export function initialise(tag: string): Promise<Result<IClarity>> {
    /* eslint-disable */
    if (instance)
        return Promise.resolve(instance);

    function clarity() { clarity.q.push(arguments); }
    // @ts-ignore
    clarity.q = [];
    // @ts-ignore
    window.clarity = clarity;

    return load_script(`https://www.clarity.ms/tag/${tag}`)
        .then(map(() => instance = clarity));
}
